import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase/firebase";
import styles from "./AuthForm.module.css";

const ForgotPassword = ({ onBack }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setIsError(false);
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setMessage("Please enter your email.");
      setIsError(true);
      return;
    }
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, trimmedEmail);
      setMessage("Check your email for a link to reset your password.");
      setEmail("");
    } catch (err) {
      setMessage(err.message || "Something went wrong. Please try again.");
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h2 className={styles.title}>Reset password</h2>
      <p className={styles.footerText} style={{ marginBottom: 16 }}>
        Enter your email and we&apos;ll send you a link to reset your password.
      </p>
      <form className={styles.form} onSubmit={handleSubmit}>
        <input
          className={styles.input}
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
          autoFocus
        />
        {message && (
          <div className={isError ? styles.error : styles.success}>
            {message}
          </div>
        )}
        <button className={styles.button} type="submit" disabled={loading}>
          {loading ? "Sending…" : "Send reset link"}
        </button>
      </form>
      <p className={styles.footerText} style={{ marginTop: 20 }}>
        <span className={styles.link} onClick={onBack}>
          Back to Login
        </span>
      </p>
    </>
  );
};

export default ForgotPassword;
